import React, { Component } from "react";
import { QUESTION_IDS, ANSWER_IDS, STRINGS, UI } from "../constants";
import { track } from "@amplitude/analytics-browser";
import { AMPLITUDE_EVENTS } from "../config/amplitude";
import { UserDetailsService } from "../services/userDetailsService";

class AdvisorInterviewQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      Advisor: [],
    };
  }

  componentDidMount() {
    // Track survey step view
    track(AMPLITUDE_EVENTS.SURVEY_VIEW_STEP, {
      page_type: "AdvisorInterviewQuestion",
      step: this.props.values.step,
      requestId: this.props.values.requestId,
      medium: this.props.values.medium,
    });

    // Use centralized service to fetch user details
    UserDetailsService.fetchAndUpdateState(
      this.props.values.requestId,
      this,
      'Advisor',
      {
        componentName: "AdvisorInterviewQuestion",
        medium: this.props.values.medium,
      }
    );
  }

  handleForm = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handlesubmit = () => {
    if (this.validateForm()) {
      if (this.props.values.options1.includes(STRINGS.OTHER)) {
        let selected = this.props.values.options1;
        let index = selected.indexOf(STRINGS.OTHER);
        selected[index] = STRINGS.OTHER + "-" + this.props.values.othersInfo;
        // selected.push(selected[index]);
        // this.setState({options1:selected}, console.log("checkbox",this.state.options1))
      }

      if (this.props.values.interviewany === ANSWER_IDS.YES_INTERVIEW) {
        var selectedYes = this.props.values.options1.toString();
      } else {
        var selectedYes = STRINGS.NA;
      }

      const obj4 = {
        requestid: this.props.values.requestId,
        medium: this.props.values.medium,
        answerId: this.props.values.interviewany,
        questionId: QUESTION_IDS.INTERVIEWED_OTHER_ADVISORS,
        responseInfo: selectedYes,
        createDt: this.props.values.date,
      };
      console.log(obj4);
      this.props.handleSubmit(obj4);
    }
  };

  validateForm() {
    let errors = {};
    let formIsValid = true;
    if (this.props.values.interviewany === "") {
      formIsValid = false;
      errors["interviewanyerror"] = "Kindly select an option below to proceed";
    }
    if (
      this.props.values.interviewany === ANSWER_IDS.YES_INTERVIEW &&
      !this.props.values.options1.length
    ) {
      formIsValid = false;
      errors["options1error"] = "Kindly select an option below to proceed";
    }

    if (
      this.props.values.options1.includes(STRINGS.OTHER) &&
      this.props.values.othersInfo === ""
    ) {
      formIsValid = false;
      errors["othersInfoerror"] = "This is a required field";
    }

    this.setState({
      errors: errors,
    });

    // Track validation errors if form is invalid
    if (!formIsValid) {
      track(AMPLITUDE_EVENTS.SURVEY_ANSWER_SUBMISSION_ERROR, {
        component: "AdvisorInterviewQuestion",
        error: "Form validation failed",
        requestId: this.props.values.requestId,
        medium: this.props.values.medium,
        step: "advisor_interview_form_validation",
        validationErrors: errors,
        errorMessages: Object.values(errors),
        errorCount: Object.keys(errors).length,
      });
    }

    return formIsValid;
  }

  back = e => {
    e.preventDefault();
    this.props.prevStep();
  };

  render() {
    const { values, handleInput, handlecheckbox1 } = this.props;

    return (
      <>
        <section className="feedback-service">
          <div className="container" style={{ textAlign: "left" }}>
            <div className="row">
              <div className="col-md-12">
                <h2>
                  In your process, did you interview any other advisor besides{" "}
                  {values.sellerName}?
                  <div id="rsp_email" className="error">
                    {this.state.errors.interviewanyerror}
                  </div>
                </h2>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="interviewany"
                    checked={values.interviewany === ANSWER_IDS.YES_INTERVIEW}
                    value={ANSWER_IDS.YES_INTERVIEW}
                    onChange={handleInput(this)}
                  />
                  Yes
                </label>
                <label className="radio-inline">
                  <input
                    type="radio"
                    name="interviewany"
                    checked={values.interviewany === ANSWER_IDS.NO_INTERVIEW}
                    value={ANSWER_IDS.NO_INTERVIEW}
                    onChange={handleInput(this)}
                  />
                  No
                </label>
              </div>
              <div className="col-md-12">
                <h2>
                  If yes, please select below:
                  <div id="rsp_email" className="error">
                    {this.state.errors.options1error}
                  </div>
                </h2>

                {this.state.Advisor.filter(
                  checkbox => checkbox.sellerNm !== values.sellerName
                ).map(checkbox => (
                  <label className="radio-inline" key={checkbox.sellerId}>
                    <input
                      type="checkbox"
                      checked={values.options1.includes(
                        checkbox.sellerNm + "(Sid-" + checkbox.sellerId + ")"
                      )}
                      name={checkbox.sellerNm}
                      disabled={
                        values.interviewany !== ANSWER_IDS.YES_INTERVIEW
                          ? "disabled"
                          : null
                      }
                      value={checkbox.sellerId}
                      onChange={handlecheckbox1}
                    />
                    {checkbox.sellerNm}
                  </label>
                ))}
                <label className="radio-inline">
                  <input
                    type="checkbox"
                    checked={
                      values.options1.includes(STRINGS.OTHER) ||
                      values.options1.includes(
                        STRINGS.OTHER + "-" + values.othersInfo
                      )
                    }
                    disabled={
                      values.interviewany !== ANSWER_IDS.YES_INTERVIEW
                        ? "disabled"
                        : null
                    }
                    value={STRINGS.OTHER}
                    onChange={handlecheckbox1}
                  />
                  Other
                </label>

                <input
                  type="text"
                  className="additional"
                  name="othersInfo"
                  value={
                    values.options1.includes(STRINGS.OTHER) ||
                    values.options1.includes(
                      STRINGS.OTHER + "-" + values.othersInfo
                    )
                      ? values.othersInfo
                      : ""
                  }
                  disabled={!values.options1.includes(STRINGS.OTHER)}
                  placeholder="IF OTHER PLEASE SPECIFY"
                  onChange={handleInput(this)}
                ></input>
                <div id="rsp_email" className="error">
                  {this.state.errors.othersInfoerror}
                </div>
              </div>

              <div className="col-md-3"></div>
              <div className="col-md-6">
                <input
                  type="button"
                  name="previous"
                  className="next btn-update action-button nextOne"
                  style={{ cursor: "pointer" }}
                  value="PREVIOUS"
                  onClick={this.back}
                />
                <input
                  type="button"
                  name="next"
                  className="next btn-update action-button nextOne"
                  style={{
                    cursor: "pointer",
                    marginLeft: UI.MARGIN_LEFT,
                  }}
                  value="NEXT"
                  onClick={this.handlesubmit}
                />
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default AdvisorInterviewQuestion;
